import styled from "styled-components";

export const Conteiner = styled.div`
  padding-top: 25px;
`;
